<template>
  <div>
    <v-carousel
      class="fixedCarosel mb-10"
      :show-arrows="false"
      hide-delimiters
      height="auto"
    >
        <!-- :href="
          $store.state.mobileMode
            ? 'https://www.campanhacorpesaude.com.br/?utm_source=banner_mobile&utm_medium=site&utm_campaign=campanha_de_vendas&utm_id=comercial'
            : 'https://www.campanhacorpesaude.com.br/?utm_source=banner_desk&utm_medium=site&utm_campaign=campanha_de_vendas&utm_id=comercial'
        " -->
      <v-carousel-item
        :src="$store.state.mobileMode ? mainBannerMob : mainBanner"
        reverse-transition="fade-transition"
        transition="fade-transition"
      ></v-carousel-item>
    </v-carousel>
    <div :class="$store.state.mobileMode ? 'mx-5' : 'mx-15'">
      <v-row no-gutters>
        <v-col class="pt-5 mb-10" cols="12" sm="12"
          ><h1 class="text-left h1 font-weight-black">
            <b class="vermelho_corpore--text">Fechamentos</b>
          </h1>
        </v-col>
        <!--  -->
        <ClosuresList />
        <!--  -->
      </v-row>
      <v-row no-gutters class="mb-15 pb-10">
        <v-col :cols="$vuetify.breakpoint.name == 'xs' ? '4' : '12'" sm="4">
          <v-btn to="/portal-corretor" class="primary mt-7"
            >{{ $store.state.mobileMode ? "" : "Área do corretor"
            }}<v-icon dark> turn_slight_left </v-icon></v-btn
          ></v-col
        >
        <v-col :cols="$vuetify.breakpoint.name == 'xs' ? '4' : '12'" sm="4">
          <v-btn elevation="0" @click="toTop" class="primary mt-7"
            >{{ $store.state.mobileMode ? "" : "Voltar ao topo"
            }}<v-icon dark> vertical_align_top </v-icon></v-btn
          ></v-col
        >
        <v-col :cols="$vuetify.breakpoint.name == 'xs' ? '4' : '12'" sm="4">
          <a href="/">
            <v-btn elevation="0" class="primary mt-7"
              >{{ $store.state.mobileMode ? "" : "Página inicial"
              }}<v-icon dark> home </v-icon></v-btn
            ></a
          ></v-col
        >
      </v-row>
      <!-- <v-row no-gutters>
        <v-col class="mt-5 mb-10 pr-15" cols="12" sm="7">
          <h2 class="text-left h2 font-weight-black">
            Fale com nosso apoio ao corretor
            <b class="vermelho_corpore--text">CORPe.</b>
          </h2>
          <p class="text-left mt-2 mb-0 pr-10">
            Entre em contato com nosso apoio e encontre o material certo para
            suas vendas!
          </p>
          <br />
          <br />
          <p class="text-left">
            Se você é cliente, consulte nossos canais de atendimento.
          </p>
        </v-col>
        <v-col class="mb-10" cols="12" sm="5">
          <GenericForm typeForm="corretor" />
        </v-col>
      </v-row> -->
    </div>
  </div>
</template>

<script>
import ClosuresList from "../../components/siteArea/ClosuresList.vue";
// import GenericForm from "../../components/common/GenericForm.vue";
export default {
  components: { ClosuresList },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
  methods: {
    handleScroll() {
      if (this.scTimer) return;
      this.scTimer = setTimeout(() => {
        this.scY = window.scrollY;
        clearTimeout(this.scTimer);
        this.scTimer = 0;
      }, 100);
    },
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  data() {
    return {
      checkbox: false,
      mainBanner: require("@/assets/banners/corretor/27-01-23 - DIGITAL_BANNER_SITE__AREACORRETOR-desktop.png"),
      mainBannerMob: require("@/assets/banners/corretor/27-01-23 - DIGITAL_BANNER_SITE__AREACORRETOR-mobile.png"),
      
      // mainBanner: require("@/assets/banners/31-08-22-corretores.png"),
      // mainBannerMob: require("@/assets/banners/31-08-22-corretores-mobile.png"),
      icCampanhas: require("@/assets/icones/ico-campanha-de-vendas-corretor.png"),
      icFechamentos: require("@/assets/icones/ico-fechamentos-corretor.png"),
      icComunicados: require("@/assets/icones/ico-comunicados-corretor.png"),
      icTabelas: require("@/assets/icones/ico-tabela-de-vendas-corretor.png"),
    };
  },
};
</script>

<style>
.fixedCarosel .v-image__image {
  background-size: contain;
  background-position: top center;
}
</style>